customElements.define('component-card-product', class CardProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const template = document.getElementById('js-card-product-template');
    this.appendChild(template.content.cloneNode(true));
    
    // Properties
    this.isFTR = false;
    if (this.getAttribute('is-ftr')) {
      this.isFTR = !!this.getAttribute('is-ftr');
    };
  
    this.productHandle = this.getAttribute('product-handle') || '';
    this.productTitle = this.getAttribute('product-title') || '';
    this.productPrice = this.getAttribute('product-price') || '';
    this.productCurrency = this.getAttribute('product-currency') || 'USD';
    this.productOriginalPrice = this.getAttribute('product-original-price') || '';
    this.image = this.getAttribute('image') || '';
    this.imageAlt = this.getAttribute('image-alt') || 'Image description';

    // DOM elements
    this.cardProductLink = this.querySelector('.card-product-link');
    this.cardProductImage = this.querySelector('.card-product-image');
    this.cardProductTitle = this.querySelector('.card-product-title');
    this.cardProductPrice = this.querySelector('.card-product-price');
    this.cardProductOriginalPrice = this.querySelector('#card-product-price-original');

    // Init
    this.cardProductLink.href = `/products/${this.productHandle}`;
    this.cardProductLink.setAttribute('data-img', this.image);
    this.cardProductImage.src = this.image;
    this.cardProductImage.alt = this.imageAlt || this.productTitle;
    this.cardProductTitle.innerHTML = this.productTitle;
    if (this.productCurrency === 'CAD') {
      this.cardProductPrice.innerHTML = `${this.productPrice} ${this.productCurrency}`;
    } else {
      this.cardProductPrice.innerHTML = `$ ${this.productPrice}`;
    }

    if (this.isFTR) {
      this.cardProductImage.classList.add('ftr');
      this.cardProductTitle.classList.add('ftr');
      this.cardProductPrice.classList.add('ftr');
    }

    if (this.productOriginalPrice) {
      this.cardProductOriginalPrice.style.display = 'inline-block';
      if (this.productCurrency === 'CAD') {
        this.cardProductOriginalPrice.innerHTML = `${this.productOriginalPrice} ${this.productCurrency}`;
      } else {
        this.cardProductOriginalPrice.innerHTML = `$ ${this.productOriginalPrice}`;
      }
    }
  }
});
